"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var Types = require("types");
var fileUploadModal_1 = require("actions/fileUploadModal");
var Buttons_1 = require("../GenericFileUploadModal/Buttons");
var mapStateToProps = function (state) {
    var uploadedFiles = Object.values(state.fileUploadModal.uploadedFiles);
    var uploaded = uploadedFiles.filter(function (item) { return item.status === 'UPLOADED'; });
    var canUpload = state.fileUploadModal.files.length > 0;
    return {
        uploadDone: state.fileUploadModal.currentUploadStatus.uploadPercentage === 100,
        allDone: uploaded.length === state.fileUploadModal.files.length &&
            state.fileUploadModal.files.length !== 0,
        uploading: uploadedFiles.length > 0,
        canUpload: canUpload,
        files: state.fileUploadModal.files,
        file: state.fileUploadModal.currentUploadStatus.fileId,
        projectId: state.project.currentProject.status === 'FETCHED'
            ? state.project.currentProject.project.id
            : NaN,
        currentFolder: state.files.currentFolder,
        currentBid: state.bid.current.bid,
        uploadSettings: state.fileUploadModal.uploadSettings
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    startUpload: function (props) {
        return props.currentFolder &&
            dispatch(fileUploadModal_1.default.fileUploadRequestAction(props.files, props.currentFolder, props.uploadSettings.unzip, props.currentBid ? false : props.uploadSettings.replace, props.file, true));
    },
    toggleModalStatus: function () { return dispatch(fileUploadModal_1.default.toggleModalStatus()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.uploadDone !== nextProps.uploadDone ||
            this.props.allDone !== nextProps.allDone ||
            this.props.uploading !== nextProps.uploading ||
            this.props.canUpload !== nextProps.canUpload ||
            this.props.uploading !== nextProps.uploading ||
            this.props.files !== nextProps.files ||
            this.props.file !== nextProps.file ||
            this.props.uploadSettings !== nextProps.uploadSettings) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(Buttons_1.Buttons, { uploadDone: props.uploadDone, canUpload: props.canUpload, uploading: props.uploading, cancelUpload: props.cancelUpload, startUpload: function () { return props.startUpload(props); }, toggleModalStatus: props.toggleModalStatus })); });
